import { Box } from "@material-ui/core";
import { useContext } from "react";
import { AutorizacaoEspecialContext } from "../../../../context/AutorizacaoEspecialContext";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import PatientComponent from "../../../components/materialui/AutorizacaoEspecial/PatientComponent";
import ParticipationRequestComponent from "../../../components/materialui/AutorizacaoEspecial/ParticipationRequestComponent";

export default function ParticipationRequestStep() {

    const { state, dispatch } = useContext(AutorizacaoEspecialContext);

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });

        if(name === "RequestParticipate" && value !== "MedicoPrincipal")
        {
            dispatch({
                type: "CLEAR_ERROR_INPUT",
                payload: { form: state.AttachmentForm, name: "RelatorioMedico" },
            });
        }

    };


    return (

        <div>

            <Steps.StepTitle text="Solicitação de participação em cirurgia" />


            <Box mt={2}>
                <ParticipationRequestComponent ParticipationRequestForm={state.ParticipationRequestForm} onInputChange={onInputChange} />
            </Box>

            <Steps.StepTitle text="Dados do Paciente" />

            <Box mt={4}>
                <PatientComponent PatientForm={state.PatientForm} onInputChange={onInputChange} />
            </Box>

        </div >

    )
}